import React, { useState, useEffect } from "react";
import "./CandidateCard.css";
import { Col, Row, Typography, Rate } from "antd";
import Frame from "../../../assets/img/Top_rated@2x.svg";
import ps_suitcase from "../../../assets/img/ps_suitcase.svg";
import { CloseOutlined } from "@ant-design/icons";
import { getImage } from "../../../utilities/storageOperations/downloadURL";
import { useSelector } from "react-redux";
import { Tooltip } from "antd";
import { DefaultRating } from "../../../assets/helpers";
import PrivateTagSkillListing from "../../PrivateMarketComponents/PrivateTagSkillListing";
import email from "../../../assets/icons/email.svg";
import phone from "../../../assets/icons/phone.svg";
import { formatPhoneNumber } from "../../../shared/helpers";
export default function CandidateCard(props) {
  const { Text } = Typography;

  const profile = useSelector((state) => state.profileReducer.user);

  const [profilePic, setProfilePic] = useState();
  const [bidType, setBidType] = useState();
  const [windowDimensions, setWindowDimensions] = useState(
		getWindowDimensions()
	);
  const [imageError, setImageError] = useState(false);
  const [imageUrl, setimageUrl] = useState("");
  // const professionCode = useSelector(state => state.profileReducer.user.profile.ProfessionCode)
  const professionCode = JSON.parse(localStorage.getItem("userProfile"));
  let userProfile = JSON.parse(localStorage.getItem("userProfile"));

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }


  useEffect(() => {
    getPicture(props.img);
  }, []);

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  useEffect(() => {
    if (props.bidType === "Year" || props.GigType === "Permanent") {
      setBidType("YR");
    } else {
      setBidType("HR");
    }
  }, [props.bidType]);

  useEffect(async () => {
    let profilePic = "";
    if (profile?.profile?.PictureUrl) {
      profilePic = await getImage(profile.profile.PictureUrl);
    }
    setProfilePic(profilePic);
  }, [profile]);

  const getPicture = (Key) => {
    var url = Key;
    if (url !== null) {
      getImage(url)
        .then((result) => {
          setimageUrl(result);
        })
        .catch(() => {});
    } else {
    }
  };

  const deleteCandidate = (item) => {
    if (props?.checkedCandidates?.length) {
      props?.setCheckedCandidates((c) =>
        c.filter((cs) => cs != item?.id)
      );
    }
    props?.setSelectedCandidates
    ((prevCandidates) => {
      const updatedCandidates = prevCandidates?.filter((p) => p.id != item?.id);
      if (updatedCandidates?.length === 0) {
        localStorage.removeItem("SelectedSkills");
        localStorage.removeItem("SelectedSkillsSearch");
      }
      return updatedCandidates;
    });
  
    props?.setSkillListingIds((ids) => {
      const updatedIds = ids.filter((s) => s?.SkillListingId != item?.id);
      if (updatedIds?.length === 0) {
        localStorage.removeItem("SelectedSkills");
        localStorage.removeItem("SelectedSkillsSearch");
      }
      return updatedIds;
    });
  
    props?.setSkillSetwithIDsAll((skill) => {
      const updatedSkills = skill.filter((sk) => sk?.skill_listing?.SkillListingId != item?.id);
      if (updatedSkills?.length === 0) {
        localStorage.removeItem("SelectedSkills");
        localStorage.removeItem("SelectedSkillsSearch");
      }
      return updatedSkills;
    });
  };
  
  return (
    <div className="condidateBidsContainer">
      <div
        style={{
          display: "flex",
          flexDirection: "row-reverse",
        }}
      >
        <Col span={24} className="imgCont">
          {professionCode?.Professions?.ProfessionCode === "IT" && professionCode?.EmployeeAssociation?.includes(props?.userSKillListing?.skill_listings?.Profiles?.Accounts?.AccountId || props?.AccountID) ? <PrivateTagSkillListing /> : null}
          <div
            className="close-bid-cont"
            onClick={() => deleteCandidate(props.item)}
          >
            {props.closeIcon ? (
              <CloseOutlined className="close-placebid" />
            ) : (
              <div className="close-div"></div>
            )}
          </div>

          <div className="top-rated">
            {/* <img className="top_rated_logo" src={Frame} />  */}
          </div>
          <div className="img-container-candidate-bids">
            {props?.img && props?.img != "/content/img/no-pic.png" && !imageError ? (
              <img
                className="profile-image-candidate-bids"
                src={`${process.env.REACT_APP_S3_URL}${
                  props?.img?.charAt(0) !== "/" ? "/" : ""
                }${props?.img}`}
                onError={() => {
                  setImageError(true);
                }}
              />
            ) : (
              <Text className="img-text-container">
                {props.name ? props.name.split("")[0].toUpperCase() : ""}
              </Text>
            )}
          </div>
        </Col>
      </div>

      <div className="container-meta-CC" style={{ color: "#1e1e1e" }}>
        {/* <div className="placebid-title"
          style={{color:'#000' , }}
          > */}
        <strong>
          {props.name &&
          props.name != null &&
          props.name != undefined &&
          props.name != ""
            ? props.name
            : props?.selectedCandidates?.name &&
              props?.selectedCandidates?.name != null &&
              props?.selectedCandidates?.name != undefined &&
              props?.selectedCandidates?.name != ""
            ? props?.selectedCandidates?.name
            : "Candidate name"}
        </strong>
        {/* </div> */}
      </div>

      <div className="rating-container">
        <Row className="ratings-div-bids">
          <Col className="ratings-column-bids">
            <Rate
             value={Number(props.rating) ?? DefaultRating}
              allowHalf
              disabled
              defaultValue={DefaultRating}
              className="rate-stars-bids"
            />
          </Col>
          <Col className="rating-text-container-bids">
            <div className="rating-text" style={{ color: "rgb(250, 219, 20)" }}>
              {props.rating ?? DefaultRating}
            </div>
          </Col>
          <Col>
            <div className="rating-text">
              {props.reviews != 0 && props.reviews != undefined
                ? `${props.reviews}`
                : null}
            </div>
          </Col>
        </Row>
      </div><Col className="skill-listing-title">
      <Tooltip title={props?.title?.length > 100 ? `${props?.title.slice(0, 100)}...` : props.title}
      trigger={['click' ,'hover']}
      >
  <div className="Job-Title" style={{ width: "100%" }}>
    {props.title}
  </div>
</Tooltip>
      </Col>
      {/* {professionCode?.Professions?.ProfessionCode !== "IT" ? ( */}
      <Row className="desired-rate-div-CC">
        <Col xs={24} className="desired-rate-CC">
          <div className="rate-value">
            <Text className="desired-rate-text">
              {professionCode?.Professions?.ProfessionCode !== "IT"
                ? "Desired rate"
                : "Est. Amount"}{" "}
            </Text>{" "}
            $
            {props.desired_rate
              ? props.desired_rate.toLocaleString("en-US")
              : "Negotiable"}
            {`/${
              props.desired_rate
                ? "/" + props.bidType === "hr" || props.bidType === "Hour"
                  ? "HR"
                  : props.bidType === "yr" || props.bidType === "Year"
                  ? "YR"
                  : props.bidType === "Week" || props.bidType === "wk"
                  ? "WK"
                  : "YR"
                : ""
            }`}
            {/* {props.bidType} */}
          </div>
        </Col>
      </Row>
      {/* ) : null} */}


<Row  style={{ 
            textAlign: 'center',
            marginTop: '2px',
            marginBottom: "5px",
            width: windowDimensions.width < 768 && '9rem',
            marginLeft:windowDimensions.width < 768 && 'auto',
            marginRight:windowDimensions.width < 768 && 'auto'}}>
            <Col lg={20} xs={24} 
            style={{
              color:' #3e3e3e',
              fontSize:' 12px',
              fontWeight:' 500',
              margin:' auto',
              borderColor:' #118936',
            }}>
              <img className="briefcase-img" src={ps_suitcase} alt="" />
              <Text style={{ marginLeft: "4%" }}>
            {props.experience ? props.experience + " of experience" : "N/A"}
          </Text>            

            </Col>
          </Row>
          
          {professionCode?.Professions?.ProfessionCode === "IT" && professionCode?.EmployeeAssociation?.includes(props?.userSKillListing?.skill_listings?.Profiles?.Accounts?.AccountId || props?.AccountID) && (
  <>
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "8px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
      <span style={{ display: "flex", alignItems: "center" }}>
        <img src={email} alt="" style={{ maxWidth: "100%", height: "auto" }} />
      </span>
      <span style={{ fontSize: "10px", overflow: "hidden", textOverflow: "ellipsis", color: "#4054B2" }}>
        {props?.userSKillListing?.skill_listings?.Profiles?.Accounts?.EmailAddress ? props?.userSKillListing?.skill_listings?.Profiles?.Accounts?.EmailAddress : props?.email ? props?.email : "N/A"}
      </span>
    </div>

    <div style={{ display: "flex", gap: "5px", justifyContent: "center", alignItems: "center" }} >
      <span style={{ display: "flex", alignItems: "center" }} ><img src={phone} alt="" /></span>
      <span style={{ fontSize: "10px", color: "#3E3E3E" }}>
        {props?.userSKillListing?.skill_listings?.Profiles?.Accounts?.MobilePhone 
          ? formatPhoneNumber(props.userSKillListing.skill_listings.Profiles.Accounts.MobilePhone.toString()) 
          : props?.MobilePhone 
            ? formatPhoneNumber(props.MobilePhone.toString()) 
            : "N/A"}
      </span>
    </div>
  </>
)}






      <div className={"last-active-text"}>
        Last active {props.lastActive ? props.lastActive : "N/A"}
      </div>
    </div>
  );
}